export const APPROVAL_AMOUNT =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";

export const CHECKPOINT_DURATION = 40;
export const CHECKPOINT_COUNT = 80;
export const WITHDRAWAL_GAS_LIMIT = 500000;
export const TVL_LIMIT = 500000;

export const HALBORN_AUDIT_LINK =
  "https://staderlabs.com/docs/Halborn/StaderLabs%20MaticX%20Smart%20Contract%20Audit%20Report%20by%20Halborn.pdf";

export const IMMUNEBYTES_AUDIT_LINK =
  "https://staderlabs.com/docs/Immunebytes/StaderLabs%20maticX%20Smart%20Contract%20Audit%20Report%20by%20Immunebytes.pdf";

export const IMMUNEFI_LINK = "https://immunefi.com/bounty/StaderforPolygon/";
